import "../../../../.cache/static-styles-react/build-javascript/compiled.js";
/** @jsxRuntime automatic @jsxImportSource @terraindigital/static-styles-react */
import { cssRef as _cssRef, mergeExternalProps as _mergeExternalProps } from "@terraindigital/static-styles-react";
const _staticStyles = _cssRef("overlay__el-1ixtj2", {
  backgroundColor: "var(--system-white)",
  position: "fixed",
  zIndex: 2000000,
  inset: 0,
  overflowY: "auto",
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  justifyContent: "center",
  alignItems: "center",
  "&[data-state='open']": {
    animation: "static-styles-overlay-kf-07cc4za8 250ms forwards"
  },
  "&[data-state='closed']": {
    animation: "static-styles-overlay-kf-29cq6p32 350ms forwards"
  },
  "@media (prefers-reduced-motion: reduce)": {
    animation: "none!important"
  }
});
import React from 'react';
import * as DialogPrimitive from '@radix-ui/react-dialog';
import { DialogContentProps } from '@radix-ui/react-dialog';
import { colors } from '../colors';

/*
* A big full-screen modal component
* */

const overlayShow = "static-styles-overlay-kf-07cc4za8";
const overlayHide = "static-styles-overlay-kf-29cq6p32";
export const Overlay = DialogPrimitive.Root;
export const OverlayTrigger = DialogPrimitive.Trigger;

/* This component houses the Overlay content */

export const OverlayContent = ({
  className,
  ...props
}: CustomProps<DialogContentProps>): JSX.Element => <DialogPrimitive.Portal>
        <DialogPrimitive.Overlay className="overlay__el-1rqyc4">
            <DialogPrimitive.Content {..._mergeExternalProps({
      css: _staticStyles,
      className: className
    }, props)} />
        </DialogPrimitive.Overlay>
    </DialogPrimitive.Portal>;

/* this component closes the Overlay */